import successIcon from "../../assets/images/success-icon.svg"
import styles from "./style.module.css"
const Success = ({successTrue}) => {
    
    return (
        <div className={styles.successContainer}>
            <img src={successIcon} alt="" />
            <h1>Congratulations
</h1>
<p>Your NIN  has been successfully linked to your Account Number. Thank You!</p>
<button onClick={successTrue}>Okay</button>
        </div>
    )
}

export default Success;